import { createFileRoute } from "@tanstack/react-router";
import { CustomButton } from "../custom/CustomButton";
import { Link as RouterLink } from "@tanstack/react-router";
import { authJwtLogout } from "../openapi/sdk.gen";

export const Route = createFileRoute("/auth/sign-out")({
  component: () => (
    <div>
      <RouterLink to="/auth/sign-in">
        <CustomButton color="primary">Sign in</CustomButton>
      </RouterLink>
    </div>
  ),
  loader: async () => {
    try {
      await authJwtLogout();
    } catch {
      /* empty */
    }
  },
});
